module.exports = __webpack_public_path__ + "img/郑州大学.aee992ce.png";